import { motion, useScroll, useSpring } from "framer-motion";

export default function ScrollProgress() {
  const { scrollYProgress } = useScroll();
  const scaleX = useSpring(scrollYProgress, { stiffness: 120, damping: 30 });
  return (
    <motion.div
      data-testid="scroll-progress"
      className="fixed top-0 left-0 right-0 h-[2px] bg-[#00cccc] z-[90] origin-left"
      style={{ scaleX, boxShadow: "0 0 12px #00cccc" }}
    />
  );
}
